import { Info } from "lucide-react";
import { type Location, type IndonesiaTZ, tzOffsetHours } from "@/data/locations";
import { displayLocationTitle } from "@/lib/prayer/copy";

function gmtLabel(tz: IndonesiaTZ): string {
  const o = tzOffsetHours(tz);
  return `GMT+${String(o).padStart(2, "0")}:00`;
}

/**
 * Google-style data source disclaimer:
 *   Menurut: Kemenag (Bimas Islam) — Cibiru, Bandung · Ubah lokasi
 *   GMT+07:00 · Waktu mungkin berubah
 */
export function DataSourceLine({
  location,
  tz,
  onChangeLocation,
}: {
  location: Location;
  tz: IndonesiaTZ;
  onChangeLocation?: () => void;
}) {
  return (
    <p className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
      <Info className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>
        Menurut: <span className="font-medium text-foreground">Kemenag (Bimas Islam)</span> — {displayLocationTitle(location)}
      </span>
      {onChangeLocation && (
        <>
          <span aria-hidden>·</span>
          <button
            type="button"
            onClick={onChangeLocation}
            className="text-prayer underline-offset-2 hover:underline"
          >
            Ubah lokasi
          </button>
        </>
      )}
      <span aria-hidden>·</span>
      <span>{gmtLabel(tz)}</span>
      <span aria-hidden>·</span>
      <span className="italic">Waktu mungkin berubah</span>
    </p>
  );
}
